<template>
  <q-select
    v-model="terms"
    :class="{ required: required }"
    dense
    outlined
    :clearable="clearable"
    use-input
    emit-value
    map-options
    options-dense
    fill-input
    hide-selected
    hide-bottom-space
    :disable="disable"
    :options="memberSearchList"
    :label="getLabel"
    :error="error"
    :error-message="errorMessage"
    @filter="search"
  >
    <template v-slot:option="scope">
      <q-item v-bind="scope.itemProps" v-on="scope.itemEvents">
        <q-item-section>
          <q-item-label v-html="scope.opt.label" />
          <q-item-label caption>{{ scope.opt.sublabel }}</q-item-label>
        </q-item-section>
      </q-item>
    </template>
    <template v-slot:no-option>
      <q-item>
        <q-item-section class="text-grey">
          {{ $t('Common.NoResult.Text') }}
        </q-item-section>
      </q-item>
    </template>
  </q-select>
</template>
<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'MemberSearchField',
  props: {
    label: {
      type: String,
    },
    error: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
    },
    payload: {
      type: Object,
      default: () => ({}),
    },
    required: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    disable: {
      type: Boolean,
      default: false,
    },
    excludeKeys: {
      type: Array,
      default: () => [],
    },
    valueAttribute: {
      type: String,
      default: 'user_id',
    },
  },
  data: () => ({
    terms: '',
    memberSearchList: [],
    selected: {},
  }),
  watch: {
    terms: {
      handler(to) {
        this.$emit('input', to)
        this.$emit('callback', to)
        let member = this.memberSearchList.find(item => item.value === to)
        if (member) {
          this.selected = { ...member }
          this.$emit('onSelectMember', member.data)
        }
      },
    },
  },
  computed: {
    ...mapState({
      membersSearchData: state => state.globalCMP.memberSearchDataGlobal,
    }),
    getLabel() {
      return this.label || this.$ts('labels.searchMember')
    },
  },
  methods: {
    ...mapActions(['getMemberSearchAction']),
    search(terms, update, abort) {
      if (terms !== '') {
        let payload = {
          ...{ search_text: terms, exclude_non_active: false, include_self: false, minimal: true, limit: 10 },
          ...this.payload,
          ...{ valueAttribute: this.valueAttribute },
        }
        if (this.excludeKeys.length > 0) {
          this.excludeKeys.forEach(x => {
            delete payload[x]
          })
        }
        this.getMemberSearchAction(payload).then(() => {
          update(() => {
            this.memberSearchList = this.membersSearchData.list
          })
        })
      } else {
        abort()
      }
    },
    getSelected() {
      return this.selected
    },
    reset() {
      this.terms = null
    },
  },
}
</script>
